export const CSS_PREFIX = 'BrandProtection'

export const SEARCH_MIN_LETTERS_REQUIRED = 1

export const SEARCH_DELAY = 800
